<template>
  <div v-if="getIsDropdownOpened" :class="getClasses" ref="popover">
    <slot />
  </div>
</template>

<script>
import CustomDropdownMixin from '@/mixins/CustomDropdownMixin';

export default {
  name: 'CustomDropdownBody',
  mixins: [CustomDropdownMixin],
  props: {
    position: {
      type: String,
      required: false,
      default: 'bottom-left',
    },
    alignTo: {
      type: String,
      required: false,
      default: 'none',
    },
    adjust: {
      type: Boolean,
      default: false,
    },
    adjustY: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      popoverStyle: {},
    };
  },
  computed: {
    getClasses() {
      return {
        [this.position]: true,
        [`align-${this.alignTo}`]: true,
        custom_dropdown_body: true,
      };
    },
  },
  mounted() {
    if (this.adjust) {
      this.adjustPosition();
      window.addEventListener('resize', this.adjustPosition);
    }
    if (this.adjustY) {
      this.adjustYPosition();
      window.addEventListener('resize', this.adjustYPosition);
    }
  },
  beforeDestroy() {
    if (this.adjust) {
      window.removeEventListener('resize', this.adjustPosition);
    }
    if (this.adjustY) {
      window.removeEventListener('resize', this.adjustYPosition);
    }
  },
  watch: {
    getIsDropdownOpened(to) {
      if (to) {
        this.$nextTick(() => {
          if (this.adjust) {
            this.adjustPosition();
          } else if (this.adjustY) {
            this.adjustYPosition();
          }
        });
      }
    },
  },
  methods: {
    adjustPosition() {
      if (this.adjust) {
        const popover = this.$refs.popover;
        if (popover) {
          const rect = popover.getBoundingClientRect();
          const windowWidth = window.innerWidth;
          if (rect.right > windowWidth) {
            popover.style.left = `${windowWidth - rect.width}px`;
            popover.style.right = 'unset';
          } else if (rect.left < 0) {
            popover.style.left = `-${rect.width + rect.left - 100}px`;
            popover.style.right = 'unset';
          }
        }
      }
    },
    adjustYPosition() {
      if (this.adjustY) {
        const popover = this.$refs.popover;
        if (popover) {
          const child = popover.children?.[0];
          if (child) {
            let id = setTimeout(() => {
              const childRect = child.getBoundingClientRect();
              if (childRect.bottom > window.innerHeight - 15) {
                child.style.bottom = '40px';
              }
              clearTimeout(id);
            }, 100);
          }
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.custom_dropdown_body {
  position: absolute;
  box-shadow: 0px 20px 45px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  top: 100%;
  margin-top: 10px;
  z-index: 10;
  &.bottom-left {
    left: 0;
    right: auto;
  }
  &.bottom-right {
    right: 0;
    left: auto;
  }
  &.align-left {
    transform: translateX(0);
  }
  &.align-right {
    transform: translateX(0);
  }
}
</style>
